// 企业用户信息
export default {
    BN: '企业名称',
    OC: '组织联系人',
    CI: '联系方式',
    AM: '授权模块',
    AV: '授权版本',
    PN: '项目名',
    IPW: 'IP白名单',
    AAK: '添加AK',
    EIPW: '编辑IP白名单',
    documentAddress: '文档地址',
    tip_IP: 'IP格式不对，请参考下方说明',
    tip_PN: '请输入项目名',
    tip_OSITI: '只有IP白名单内的服务器才能成功发起调用',
    tip_Format: '格式: 202.198.16.3,202.198.0.0/16 填写IP地址或IP前缀网段，英文半角逗号分隔如果不想对IP做任何限制，请设置为0.0.0.0/0',
    tip_UIWC: '（谨慎使用，AK如果泄露配额会被其用户消费，上线前可以用作Debug，线上正式ak请设置合理的IP白名单）',
}